<script setup lang="ts">
  const version = __APP_VERSION__
  const companyNameLong = import.meta.env.VITE_APP_COMPANY_NAME_LONG as string
  import logoAuth from '@/assets/images/logo-auth.png'
  import { copyrightYear } from '@/functions/copyright-year'
</script>

<template>
  <div class="relative min-h-144 h-screen">
    <div class="bg-auth"></div>
    <div class="inset-0 absolute flex-center">
      <div class="card max-w-[calc(100vw-48px)] w-sm">
        <img
          :src="logoAuth"
          class="size-26 mx-auto p-2 bg-white -mb-12 -translate-y-12 rounded-full"
          :alt="'logo ' + companyNameLong">

        <app-router-view />
      </div>
    </div>
    <div class="absolute text-xs text-center text-white inset-x-0 bottom-4">
      v{{ version }}. &copy;{{ copyrightYear() }} {{ companyNameLong }}
    </div>
  </div>
</template>

<style scoped>
  .bg-auth {
    background-image: url("@/assets/images/bg-auth.png");
    background-size: cover;
    /* background-repeat: ; */
    background-position: center;
    position: fixed;
    inset: 0;
  }
</style>
